import { Mail, type LucideIcon } from 'lucide-react';

export type MarketingPageId = 'email-campaigns';

export interface MarketingNavPage {
  id: MarketingPageId;
  label: string;
  description: string;
  icon: LucideIcon;
}

interface MarketingNavWidgetsProps {
  pages: MarketingNavPage[];
  onOpenPage: (pageId: MarketingPageId) => void;
}

/**
 * Formerly “More in Marketing” widgets. Templates and Referral now live in the
 * Email & SMS top tab bar — this returns null when nothing remains.
 */
export default function MarketingNavWidgets(_props: MarketingNavWidgetsProps) {
  return null;
}

/** Shared nav config for Marketing shell. */
export const MARKETING_NAV_PAGES: MarketingNavPage[] = [
  {
    id: 'email-campaigns',
    label: 'Email & SMS Campaigns',
    icon: Mail,
    description: 'Campaign calendar, sends, lists, and settings',
  },
];
